module.exports = __webpack_public_path__ + "static/media/the-toast.4ab076ca.png";